import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    borderRadius:'10px',
    //width: '200px',
    //height: '35px',
    //position: 'relative',
    float: 'right',
    bottom: 0,
    //marginTop:'-60px',
    textAlign: 'center',
    //paddingLeft: '5px',
    //paddingTop: '5px',
    padding:'5px 20px',
    //marginTop:'20px',
    //lineHeight: '20px',
    backgroundColor: 'rgba(128,128,128,0.5)',
    color: '#000',
    //fontWeight:700,
    zIndex: 500,
  },
  /*
  bottomContainer:{
    //marginTop:'-60px',
    //fontWeight:700,
    //marginTop:'20px',
    display: 'flex',
    justifyContent: 'space-between',
    borderRadius:'10px',
    //width: '75%',
    height: '50px',
    //position: 'relative',
    float: 'right',
    marginRight:'0 10px',
    //bottom: 0,
    textAlign: 'center',
    //paddingLeft: '5px',
    //paddingTop: '5px',
    lineHeight: '20px',
    backgroundColor: 'rgba(187,187,187,0.5)',
    //color: '#fff',
    color: '#000',
    zIndex: 500,
    //[theme.breakpoints.down('sm')]: {
    //  width: '95%',
    //},
  },
  */
  linksContainer: {
    
    display: 'block',
    //width: '220px',
    //width: '75%',
    fontSize:'10pt',
    /*
    fontSize:'0.85em',
    [theme.breakpoints.down('sm')]: {
      fontSize:'9pt',
      width: '90%',
    },
    [theme.breakpoints.up('lg')]: {
      width: '80%',
    },
    */

  },
  link: {
    color: '#000',
    textDecoration: 'none',
    '&:hover': {
      cursor: 'pointer',
      //color: 'grey!important',
      //fontWeight: 700,
    },
  },
  /*
  imageContainer: {
    textAlign: 'right',
    //backgroundColor:'red',
    width: '25%',
  },  
  image: {
    display: 'block',
    margin: '0 auto',
    backgroundSize: 'auto',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center!important',
    width: '80%',
    height: 0,
    minWidth:'35px',
    maxWidth:'35px',
    minHeight: '35px',
    maxHeight: '35px',
    backgroundImage: 'url("/images/3E_logo.svg")',
  },
  */
});


function Copyright(props) {
  const { classes } = props;

  let poweredBy
  //let withSupportFrom
  //let brusselsRegion
  //let brusselsRegionLink

  switch (props.lang) {
    case "de":
      //switchToHistorical="Year View"
      poweredBy = "Powered by"
      //withSupportFrom = "With the support from "
      //brusselsRegion = "Brussels-Capital Region"
      //brusselsRegionLink = "https://be.brussels/brussels"
      break;
    case "en":
      //switchToHistorical="Year View"
      poweredBy = "Powered by"
      //withSupportFrom = "With the support from "
      //brusselsRegion = "Brussels-Capital Region"
      //brusselsRegionLink = "https://be.brussels/brussels"
      break;

    default:
    case "fr":
      poweredBy = "Powered by"
      //withSupportFrom = "Avec le soutien de la "
      //brusselsRegion = "Région de Bruxelles-Capitale"
      //brusselsRegionLink = "https://be.brussels/bruxelles?set_language=fr"

  }

  return (
    <div className={classes.container}>
      <div className={classes.linksContainer}>
        <div><a href="http://www.3e.eu/" className={classes.link}>{poweredBy} 3E</a></div>
        <div>© <a href="http://www.3e.eu/data-services/" className={classes.link}>3E Data Services</a></div>
        {
          /*
        
        <div>{withSupportFrom} <a href={brusselsRegionLink} className={classes.link}>{brusselsRegion}</a></div>
          */
        }
      </div>
      {
      /*
        <div className={classes.imageContainer}>
          <div className={classes.image} />
        </div>
      */
      }
    </div>
  );
}

Copyright.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Copyright);